import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { getHistoricOfLead } from '../../../graph-ql/queries';
import { HistoricResponse } from '../../models/historic/historic.response';
import { HistoricByLeadInput } from '../../models/historic/HistoricByLeadInput';

@Injectable()
export class HistoricService {

  constructor(public apollo: Apollo) {
  }

  getHistoricByLead$(input: HistoricByLeadInput): Observable<HistoricResponse> {
    return this.apollo.query<HistoricResponse>({
      query: getHistoricOfLead,
      variables: {
        input
      }
    }).pipe(map(result => new HistoricResponse(result.data['getHistoricOfLead']['historics'],
      result.data['getHistoricOfLead']['totalItems'])));
  }
}
